import { AloftArea, ConstellationOneListing } from '@aloft/toolkit-shared';

import MLSDataColumn from './MLSDataColumn.js';
import MLSDataInfoSection from './MLSDataInfoSection.js';
import MlsDataValueWithLabel from './MLSDataValueWithLabel.js';
import { getLotAreaSqftString } from './utils/getLotAreaSqftString.js';

const MLSSiteInfo = ({ listingData }: { listingData: ConstellationOneListing }) => (
  <MLSDataInfoSection title="Site">
    <MLSDataColumn>
      <MlsDataValueWithLabel value={getLotAreaSqftString(listingData)} label="Lot Size (Sq Ft)" />
      <MlsDataValueWithLabel
        value={
          listingData.LotSizeAcres
            ? AloftArea.fromNumber(listingData.LotSizeAcres, 'acre').toString()
            : undefined
        }
        label="Lot Acres"
      />
      <MlsDataValueWithLabel value={listingData.WaterSource?.join(', ')} label="Water" />
      <MlsDataValueWithLabel value={listingData.Sewer} label="Sewer" />
      <MlsDataValueWithLabel value={listingData.LotFeatures} label="Lot Description" />
    </MLSDataColumn>
    <MLSDataColumn>
      <MlsDataValueWithLabel value={listingData.Topography} label="Topography" />
      <MlsDataValueWithLabel value={listingData.View} label="View" />
      <MlsDataValueWithLabel value={listingData.WaterFrontYN} label="Waterfront" />
      {listingData.WaterFrontYN && (
        <MlsDataValueWithLabel value={listingData.WaterFrontFeatures} label="Waterfront Features" />
      )}
      <MlsDataValueWithLabel value={listingData.ParcelNumber} label="Parcel Number" />
    </MLSDataColumn>
  </MLSDataInfoSection>
);

export default MLSSiteInfo;
